import { TableModel } from 'components/table/IdmTable';
import { format, parseISO } from 'date-fns';

export type ItineraryRecomputationsElement = {
  id: number;
  date: string;
  itineraryRecomputationsCount: number;
  onClickHandler: () => void;
};

const itineraryRecomputationModel: TableModel<ItineraryRecomputationsElement> =
  {
    columns: [
      {
        title: 'Courier Id',
        html: (e: ItineraryRecomputationsElement) => <span>{e.id}</span>,
      },
      {
        title: 'Date',
        html: (e: ItineraryRecomputationsElement) => (
          <span>{format(parseISO(e.date), 'dd-MM-yyyy')}</span>
        ),
      },
      {
        title: 'Itinerary Recomputations Count',
        html: (e: ItineraryRecomputationsElement) => (
          <span
            className={e.itineraryRecomputationsCount > 5 ? 'text-red' : ''}
          >
            {e.itineraryRecomputationsCount}
          </span>
        ),
      },
      {
        title: 'Itinerary Details',
        html: (e: ItineraryRecomputationsElement) => (
          <span>
            <button type="button" onClick={e.onClickHandler}>
              View itinerary Details
            </button>
          </span>
        ),
      },
    ],
  };

export default itineraryRecomputationModel;
